import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";
import { createSelector } from "reselect";
import { apiError, logoutUserSuccess } from "../../slices/auth/login/reducer";
import { useAuth } from "../../Provider/AuthProvider";

const Logout = () => {
  const dispatch: any = useDispatch();
    const { logout } = useAuth();


  const logoutData = createSelector(
    (state) => state.Login,
    (isUserLogout) => isUserLogout.isUserLogout
  );

  // Inside your component
  const isUserLogout = useSelector(logoutData);

 const SignOut = () => async (dispatch: any) => {
        try {
            //localStorage.removeItem("authUser");
            logout();
            dispatch(logoutUserSuccess(true));
        } catch (error: any) {
            dispatch(apiError(error));
        }
    };


  useEffect(() => {
      dispatch(SignOut());
  }, [dispatch]);

  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return <React.Fragment></React.Fragment>;
};

Logout.propTypes = {
  history: PropTypes.object,
};


export default withRouter(Logout);